import { useColorModeValue } from '@chakra-ui/react';

export default function useMenuColors() {
  const themedBackground = useColorModeValue('blackAlpha.50', 'whiteAlpha.50');
  const themedBorderColor = useColorModeValue('#000', 'gray.700');
  const themedColor = useColorModeValue('#000', 'gray.400');

  return { themedBackground, themedBorderColor, themedColor };
}
